module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-ursonate__page-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTextMin),
      expression: "isTextMin"
    }],
    staticClass: "ksm-medien__icon-fixed ksm-link--svg2",
    attrs: {
      "title": "Bereich wiederherstellen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('text.svg'))
    },
    on: {
      "click": function($event) {
        _vm.isTextMin = false
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNotenMin),
      expression: "isNotenMin"
    }],
    staticClass: "ksm-medien__icon-fixed--right ksm-link--svg2",
    attrs: {
      "title": "Bereich wiederherstellen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('noten.svg'))
    },
    on: {
      "click": function($event) {
        _vm.isNotenMin = false
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAudioMin),
      expression: "isAudioMin"
    }],
    staticClass: "ksm-medien__icon-fixed--bottom ksm-link--svg2",
    attrs: {
      "title": "Bereich wiederherstellen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('audio.svg'))
    },
    on: {
      "click": function($event) {
        _vm.isAudioMin = false
      }
    }
  }), _vm._v(" "), _c('g-play-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAudioMin),
      expression: "isAudioMin"
    }],
    staticClass: "ksm-medien__icon-fixed--bottom ksm-link--svg2",
    staticStyle: {
      "bottom": "20pt"
    },
    attrs: {
      "isPlaying": _vm.audioIsPlaying
    },
    on: {
      "click": _vm.audioToggle
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVideoMin),
      expression: "isVideoMin"
    }],
    staticClass: "ksm-medien__icon-fixed--bottom_right ksm-link--svg2",
    attrs: {
      "title": "Bereich wiederherstellen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('film-neu.svg'))
    },
    on: {
      "click": function($event) {
        _vm.isVideoMin = false
      }
    }
  }), _vm._v(" "), _c('splitpanes', {
    staticClass: "default-theme",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "horizontal": "",
      "watch-slots": "",
      "dbl-click-splitter": false
    },
    on: {
      "resize": _vm.resizeRowTop
    }
  }, [_c('splitpanes', {
    attrs: {
      "watch-slots": "",
      "splitpanes-size": _vm.rowTop,
      "splitpanes-min": "1",
      "dbl-click-splitter": false
    },
    on: {
      "resize": _vm.resizeColumnTopLeft
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__pane",
    attrs: {
      "splitpanes-size": _vm.columnTopLeft,
      "splitpanes-min": "1"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__box-wrapper"
  }, [_c('div', {
    staticClass: "ksm-ursonate__box"
  }, [_c('TextView', {
    attrs: {
      "themaPlaying": _vm.themaPlaying,
      "isConnect1": _vm.isConnect1
    }
  }), _vm._v(" "), _c('OpenCloseButtons', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isNotenMin || !_vm.isAudioMin || !_vm.isVideoMin),
      expression: "!isNotenMin || !isAudioMin || !isVideoMin"
    }],
    attrs: {
      "showMerz24": true
    },
    on: {
      "minimize": function($event) {
        return _vm.minimize('text')
      },
      "fullsize": function($event) {
        return _vm.fullsize('text')
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate__pane",
    attrs: {
      "splitpanes-size": 100 - _vm.columnTopLeft,
      "splitpanes-min": "1"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__box-wrapper"
  }, [_c('div', {
    staticClass: "ksm-ursonate__box"
  }, [_c('NotenView'), _vm._v(" "), _c('OpenCloseButtons', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTextMin || !_vm.isAudioMin || !_vm.isVideoMin),
      expression: "!isTextMin  || !isAudioMin || !isVideoMin"
    }],
    on: {
      "minimize": function($event) {
        return _vm.minimize('note')
      },
      "fullsize": function($event) {
        return _vm.fullsize('note')
      }
    }
  })], 1)])])]), _vm._v(" "), _c('splitpanes', {
    attrs: {
      "watch-slots": "",
      "splitpanes-size": 100 - _vm.rowTop,
      "splitpanes-min": "1",
      "dbl-click-splitter": false
    },
    on: {
      "resize": _vm.resizeColumnBottomLeft
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__pane",
    attrs: {
      "splitpanes-size": _vm.columnBottomLeft,
      "splitpanes-min": "1"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__box-wrapper"
  }, [_c('g-connect-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTextMin && !_vm.isAudioMin),
      expression: "!isTextMin && !isAudioMin"
    }],
    ref: "all_play_btn_1",
    staticStyle: {
      "position": "absolute",
      "top": "-35px",
      "left": "100px",
      "z-index": "300"
    },
    on: {
      "connectClick": _vm.doConnect1
    }
  }), _vm._v(" "), _c('g-connect-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAudioMin && !_vm.isVideoMin),
      expression: "!isAudioMin && !isVideoMin"
    }],
    ref: "all_play_btn_2",
    staticStyle: {
      "position": "absolute",
      "top": "100px",
      "left": "-5px",
      "z-index": "300"
    },
    attrs: {
      "rotate": "vertical"
    },
    on: {
      "connectClick": _vm.doConnect2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate__box ksm-flex-x-center"
  }, [_c('AudioView', {
    attrs: {
      "isConnect2": _vm.isConnect2
    },
    on: {
      "audioChange": _vm.audioChange
    }
  }), _vm._v(" "), _c('OpenCloseButtons', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTextMin || !_vm.isNotenMin || !_vm.isVideoMin),
      expression: "!isTextMin || !isNotenMin || !isVideoMin"
    }],
    on: {
      "minimize": function($event) {
        return _vm.minimize('audio')
      },
      "fullsize": function($event) {
        return _vm.fullsize('audio')
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate__pane",
    attrs: {
      "splitpanes-size": 100 - _vm.columnBottomLeft,
      "splitpanes-min": "1"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__box-wrapper"
  }, [_c('div', {
    staticClass: "ksm-ursonate__box ksm-flex-x-center"
  }, [_c('FilmView', {
    attrs: {
      "isConnect2": _vm.isConnect2
    }
  }), _vm._v(" "), _c('OpenCloseButtons', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTextMin || !_vm.isNotenMin || !_vm.isAudioMin),
      expression: "!isTextMin || !isNotenMin || !isAudioMin"
    }],
    on: {
      "minimize": function($event) {
        return _vm.minimize('video')
      },
      "fullsize": function($event) {
        return _vm.fullsize('video')
      }
    }
  })], 1)])])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2ee77ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/texte/MedienOverview.vue
// module id = 1999
// module chunks = 1